import { Directive, HostBinding, Input } from '@angular/core';


@Directive({
  selector: 'a:not([routerLink])',
})
export class ExternalLink {
  @HostBinding('style.cursor')
  @Input()
  cursor = 'pointer';

  @HostBinding('rel')
  @Input()
  rel = 'nofollow';

  @HostBinding('target')
  @Input()
  target = '_blank';
}